<template>
  <div>
    <base-dialog
      @save-item="saveItem"
      dialogId="create-client-portal-dialog"
      :open.sync="openDialog"
      :form-ref.sync="clientPortalFormRef"
      :loading.sync="isLoading"
    >
      <template v-slot:[`dialog.title`]>
        <span>Créer un portail client</span>
      </template>
      <template v-slot:[`dialog.content`]>
        <v-container>
          <client-portal-form
            :client-portal-form.sync="clientPortalForm"
            :rules="rules"
          ></client-portal-form>
        </v-container>
      </template>
      <template v-slot:[`dialog.actions.save`]>Créer</template>
    </base-dialog>
  </div>
</template>
<script>
import { toRefs, computed } from "@vue/composition-api";
import { useClientPortal } from "@/composables/client-portal";
import ClientPortalForm from "@/components/ClientPortal/ClientPortalForm";
import BaseDialog from "@/components/General/BaseDialog.vue";

export default {
  components: {
    ClientPortalForm,
    BaseDialog,
  },
  props: {
    clientPortal: Object,
    open: Boolean,
  },
  setup(props, { root, emit }) {
    /* Import des API */
    const { createClientPortal, data } = useClientPortal();

    /* Méthodes */
    const saveItem = async function () {
      await createClientPortal();
      openDialog.value = false;
    };

    /* Variables */

    /* Computed */
    const isMobile = computed(function () {
      return root.$vuetify.breakpoint.mobile;
    });
    const openDialog = computed({
      get: function () {
        return props.open;
      },
      set: function (value) {
        emit("update:open", value);
      },
    });

    return {
      ...toRefs(data),
      createClientPortal,
      isMobile,
      saveItem,
      openDialog,
    };
  },
};
</script>
